import React from 'react';
import { useNavigate } from 'react-router-dom'
import { Button } from '../components/button'
export function AlertBanner() {
  const navigate = useNavigate();
  return (  
    <div className="mb-6 text-center bg-white p-4 shadow-sm rounded-lg">
      <p className="text-lg mb-2">
        Looks like your Google Ads account isn’t linked yet, so test title creation is currently disabled.
      </p>
      <p className="flex justify-center items-center gap-2">
        <span>Connect your account here:</span>
		  <Button color="zinc" onClick={() => navigate("/adwords-sync")}>
		      Google ads Connect
		  </Button>  
      </p>
    </div> 
  );
}
